<template>
  <div class="overflow-auto p-4 h-full">
    <div class="pb-6 h-full" v-if="htmlContent" v-html="htmlContent"></div>
  </div>
</template>

<script setup lang="ts">
import { onMounted, ref, watch } from 'vue';
import type { SalesPerson } from '@/types/SalesPersons';
import { getCustomerHtmlTabs } from '@/services/api/traders';

const props = defineProps<{
  modelValue?: SalesPerson;
  salesperson?: SalesPerson;
  mode: 'view' | 'edit';
  isHorizontalLayout?: boolean;
}>();

const htmlContent = ref<string>('');

async function fetchBalance() {
  if (props.salesperson && props.salesperson.boid) {
    const result = await getCustomerHtmlTabs({
      enumValue: 8,
      materialBoid: props.salesperson.boid,
    });
    if (result) htmlContent.value = result;
  }
}

onMounted(fetchBalance);
watch(
  () => props.salesperson?.boid,
  () => {
    htmlContent.value = '';
    fetchBalance();
  }
);
</script>
